import {Component, Input, Output, OnChanges, SimpleChanges, EventEmitter} from '@angular/core';
import {ImageService} from '../../../services/image/image.service';
import {S3UploaderRatios, S3UploaderRatioEnum, S3UploaderTypes, S3UploaderTypesEnum} from '../uploader/s3-uploader.types';
import {finalize, tap} from 'rxjs';
import {UtilService} from "../../../services/util/util.service";

@Component({
  selector: 'app-s3-downloader',
  templateUrl: './s3-downloader.component.html',
  styleUrls: ['./s3-downloader.component.scss']
})
export class S3DownloaderComponent implements OnChanges {
  @Input() public model: string;
  @Input() public ratio: S3UploaderRatioEnum;
  @Input() public type: S3UploaderTypesEnum = S3UploaderTypes.Venue;
  @Input() public ownerCentreId: number;
  @Input() public ownerId: number;
  @Input() public noBorder: boolean;
  @Input() public slim: boolean;
  @Input() public badge: boolean;
  @Input() public originalSize: boolean;
  @Input() public inline: boolean;
  @Input() public thumb: boolean;
  @Input() public onlyUrl: boolean;
  @Input() public customContainer: boolean;
  @Input() public backgroundBased: boolean;
  @Output() public loadingChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public imageLoaded: EventEmitter<Blob | string> = new EventEmitter<Blob | string>();

  public preview: string;
  public isLoading: boolean;
  public S3UploaderRatios = S3UploaderRatios;

  constructor(private imageService: ImageService) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.model) {
      this.downloadImage();
    }
  }

  private downloadImage(): void {
    if (this.model) {
      this.isLoading = true;
      this.loadingChange.emit(true);
      const filename = UtilService.getS3ImageFileName(this.model, this.ratio === S3UploaderRatios.Email ? null : this.ratio, this.thumb);
      if (this.type === S3UploaderTypes.Venue) {
        this.imageService.downloadVenueImage(filename, this.ownerCentreId ? this.ownerCentreId.toString() : null).pipe(
          finalize(() => {
            this.isLoading = false;
            this.loadingChange.emit(false);
          })
        ).subscribe((blob) => this.processBlob(blob));
      } else if (this.type === S3UploaderTypes.Event) {
        this.imageService.downloadEventImage(filename, this.ownerCentreId ? this.ownerCentreId.toString() : null).pipe(
          tap({ error: () => this.showEventPlaceHolder() }),
          finalize(() => {
            this.isLoading = false;
            this.loadingChange.emit(false);
          })
        ).subscribe((blob) => this.processBlob(blob));
      } else if (this.type === S3UploaderTypes.Legal) {
        this.imageService.downloadLegalImage(filename, this.ownerId ? this.ownerId.toString() : null).pipe(
          finalize(() => {
            this.isLoading = false;
            this.loadingChange.emit(false);
          })
        ).subscribe((blob) => this.processBlob(blob));
      }
    } else {
      this.preview = '';
    }
  }

  private processBlob(blob: Blob): void {
    this.preview = URL.createObjectURL(blob);
    this.imageLoaded.emit(this.onlyUrl ? this.preview : blob);
    this.isLoading = false;
    this.loadingChange.emit(false);
  }

  private showEventPlaceHolder(): void {
    this.preview = '/assets/img/jpg/event-placeholder-' + (this.ratio || S3UploaderRatios.Modern) + '.jpg';
    this.imageLoaded.emit(this.preview);
  }
}
